import React, { Component } from "react";
import {
	Container,
	Card,
	CardHeader,
	Button,
	CardBody,
	Row,
	Table,
	Col,
} from "reactstrap";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import moment from "moment";
// import DefaultImg from "../../../assets/images/product/Default_img.jpg";

import { ExportToExcel } from "../../Common/ExportToExcel";
import { getPOAmendamentReportslist } from "../../../store/Reports/actions";
import LoadingModel from "../../LoadingModel";
import "../reports.scss";
var date = new Date(),
	y = date.getFullYear(),
	m = date.getMonth();
class POReportList extends Component {
	constructor(props) {
		super(props);
		this.state = {};
	}

	componentDidMount() {
		this.props.getPOAmendamentReportslist({
			...this.props.params,
			start_date:
				this.props.params.start_date == null ||
				this.props.params.start_date === ""
					? moment(new Date(y, m, 1)).format("YYYY-MM-DD")
					: this.props.params.start_date,
			end_date:
				this.props.params.end_date == null ||
				this.props.params.end_date === ""
					? moment(new Date()).add(1, "days").format("YYYY-MM-DD")
					: moment(this.props.params.end_date)
							.add(1, "days")
							.format("YYYY-MM-DD"),
			purchaseorder: this.props.match.params.id,
		});
	}

	render() {
		return (
			<React.Fragment>
				<div className="page-content">
					<Container fluid>
						 {this.props.loading && (
              <LoadingModel OpenModel={this.props.loading} />
            )}
						<Row>
							<Col md={12}>
								<Card>
									<CardHeader className="bg-transparent border-bottom no-print">
										<Link
											to="/pohistory"
											className="action-icon text-primary mr-2">
											<i className="mdi mdi-arrow-left-bold-circle-outline font-size-20"></i>
										</Link>
										<div className="float-right">
											<div className="d-inline-block ">
												<ExportToExcel
													apiData={
														this.props
															.PO_Amendament_ReportData
															.length != 0
															? this.props.PO_Amendament_ReportData.map(
																	(po) => {
																		return {
																			"PO Code":
																				po.purchaseorder_code,
																			"Vendor Name":
																				po.vendor_name,
																			"Item Name":
																				po
																					.product
																					.name,
																			"Item Base Price":
																				po.baseprice,
																			"Item Discount(%)":
																				po.discountpercent,
																			"Tax Type(%)": `${po.taxtype_name} ${po.tax?.name}`,
																			"No of Days of PO":
																				parseInt(
																					(new Date() -
																						new Date(
																							po.modifiedon
																						)) /
																						(1000 *
																							60 *
																							60 *
																							24)
																				),
																			"Modified On":
																				moment(
																					po.modifiedon
																				).format(
																					"LLL"
																				),
																			"Modified By": `${po.modified_by?.fullname} (${po.modified_by?.username})`,
																		};
																	}
															  )
															: []
													}
													topHeader={[
														"SRI LALITHA ENTERPRISES INDUSTRIES PVT. LTD",
														"Valuthimmapuram Road, PEDDAPURAM - 533437, E.G. Dist. - AP",
														"Phone No.0884-2326661, 62, Mobile No.9494127893, Email: purchase@sleipl.com, lalitharice@gmail.com",
														"",
														"PURCHASE ORDER AMENDAMENT REPORT",
														"",
													]}
													fileName="PurchaseOrderHistory"
												/>
												{/* <Button
                          type="button"
                          outline
                          color="secondary"
                          className=" mr-2"
                          onClick={() => this.getExcelReport()}
                        >
                          <i className="ri-file-excel-2-line"></i>
                          <span className="d-none d-inline-block ml-1">
                            Excel
                          </span>
                        </Button> */}
												{/* <ReactHTMLTableToExcel
                          id="test-table-xls-button"
                          className=" mr-2"
                          // className="download-table-xls-button"
                          table="table-to-xls"
                          filename="tablexls"
                          sheet="tablexls"
                          buttonText="Excel"
                        /> */}
												<Button
													type="button"
													outline
													color="secondary"
													className=" ml-2"
													onClick={() =>
														window.print()
													}>
													<i className="mdi  mdi-printer"></i>
													<span className="d-none d-inline-block ml-1">
														Print
													</span>
												</Button>
											</div>
										</div>
									</CardHeader>
									<CardBody className="pt-2">
										<div className="text-center">
											<span className="display_none printme">
												<h5 className="card-title-18 pt-2 ">
													SRI LALITHA ENTERPRISES
													INDUSTRIES PVT. LTD
												</h5>
												<p className="card-title-14 pt-2 mb-0">
													Valuthimmapuram Road,
													PEDDAPURAM - 533437, E.G.
													Dist. - AP
												</p>
												<p className="card-title-14 pt-2">
													Phone No.0884-2326661, 62,
													Mobile No.9494127893, Email:
													purchase@sleipl.com,
													lalitharice@gmail.com
												</p>
												 
												<hr />
											</span>
											<h5 className="card-title-16 pt-3 ">
												PURCHASE ORDER AMENDAMENT REPORT
												({" "}
												{this.props.params.start_date ==
													null ||
												this.props.params.start_date ===
													""
													? moment(
															new Date(y, m, 1)
													  ).format("DD-MM-YYYY")
													: moment(
															this.props.params
																.start_date
													  ).format(
															"DD-MM-YYYY"
													  )}{" "}
												TO{" "}
												{moment(
													this.props.params.end_date
												).format("DD-MM-YYYY")}{" "}
												)
											</h5>
										</div>

										<div className="table-responsive m-0">
											<Table
												bordered
												hover
												className="mb-0 p-0 table-centered"
												id="table-to-xls">
												<thead className="bg-light text-center ">
													<tr className="bg-light">
														<th
															style={{
																width: "2%",
															}}>
															<b>S.No.</b>
														</th>

														<th
															style={{
																width: "8%",
															}}>
															<b>PO Code</b>
														</th>

														<th
															style={{
																width: "15%",
															}}>
															<b>Vendor Name</b>
														</th>
														<th
															style={{
																width: "10%",
															}}>
															<b>Item Name</b>
														</th>
														<th className="nowrap text-center table_head">
															Item Base Price
														</th>
														<th className="nowrap text-center table_head">
															Item Discount(%)
														</th>

														<th className="nowrap text-center table_head">
															Tax Type(%)
														</th>
														<th
															style={{
																width: "5%",
															}}>
															<b>
																No of Days of PO
															</b>
														</th>
														<th
															style={{
																width: "10%",
															}}>
															<b>Modified On</b>
														</th>
														<th
															style={{
																width: "10%",
															}}>
															<b>Modified By</b>
														</th>
													</tr>
												</thead>
												<tbody>
													{this.props
														.PO_Amendament_ReportData
														.length !== 0 ? (
														<>
															{this.props.PO_Amendament_ReportData.map(
																(po, key) => (
																	<>
																		<tr
																			key={
																				key
																			}
																			className="text-center">
																			<td>
																				{key +
																					1}
																			</td>
																			<td>
																				{
																					po.purchaseorder_code
																				}
																			</td>

																			<td>
																				{
																					po.vendor_name
																				}
																			</td>
																			<td>
																				{
																					po
																						.product
																						.name
																				}
																			</td>
																			<td className="nowrap text-center">
																				{
																					po.baseprice
																				}
																			</td>
																			<td className="nowrap text-center">
																				{
																					po.discountpercent
																				}
																			</td>

																			<td className="nowrap text-center">
																				{`${po.taxtype_name} ${po.tax.name}`}
																			</td>
																			<td>
																				{parseInt(
																					(new Date() -
																						new Date(
																							po.modifiedon
																						)) /
																						(1000 *
																							60 *
																							60 *
																							24)
																				)}
																			</td>
																			<td>
																				{moment(
																					po.modifiedon
																				).format(
																					"LLL"
																				)}
																			</td>
																			<td>
																				{
																					po
																						.modified_by
																						?.fullname
																				}{" "}
																				{`(${po.modified_by?.username})`}
																			</td>
																		</tr>
																	</>
																)
															)}
														</>
													) : (
														<tr>
															<td
																colspan="9"
																className="text-center">
																<span className="font-size-18 text-danger">
																	Data not
																	available
																</span>
															</td>
														</tr>
													)}
												</tbody>
											</Table>
										</div>
									</CardBody>
								</Card>
							</Col>
						</Row>
					</Container>
				</div>
			</React.Fragment>
		);
	}
}

const mapStatetoProps = (state) => {
	const { params, reportType, Reportdata, PO_Amendament_ReportData ,loading} =
		state.reports;
	return {
		params,
		reportType,
		Reportdata,
		PO_Amendament_ReportData,
		loading,
	};
};

export default connect(mapStatetoProps, {
	getPOAmendamentReportslist,
})(POReportList);
